import { useMutation } from "@tanstack/react-query";
import { selfHireService } from "../services/selfHireService";
import { useToast } from "@/view/components/ui/use-toast";
import { GenerateOffersPanPayload } from "../services/selfHireService/generateOffersPan";
import { MakeProposalCrefazPayload } from "../services/selfHireService/makeProposalCrefaz";
import { GetPublicTransactionParams } from "../services/selfHireService/getPublicTransaction";
import { SendProposalRequest } from "../services/panService/sendProposal";
import { SimulateCltParams } from "../services/selfHireService/simulateClt";

export function useSelfHiringMutation() {
  const { toast } = useToast();

  const createCustomerMutation = useMutation({
    mutationFn: selfHireService.createPublicCustomer,
    onError: () => {
      toast({
        variant: "destructive",
        title: "Ocorreu um erro, tente novamente mais tarde.",
      });
    },
  });

  const makeProposalPanMutation = useMutation({
    mutationFn: selfHireService.createPanTransaction,
    onError: () => {
      toast({
        variant: "destructive",
        title: "Erro ao criar proposta",
      });
    },
  });

  const generateOffersPanMutation = useMutation({
    mutationFn: ({
      linkName,
      payload,
    }: {
      linkName: string;
      payload: GenerateOffersPanPayload;
    }) => selfHireService.generateOffersPan(linkName, payload),
    onError: () => {
      toast({
        variant: "destructive",
        title: "Erro ao gerar ofertas",
      });
    },
  });

  const getPublicTransactionPanMutation = useMutation({
    mutationFn: (params: GetPublicTransactionParams) =>
      selfHireService.getPublicTransactionPan(params),
    onError: () => {
      toast({
        variant: "destructive",
        title: "Ocorreu um erro, tente novamente mais tarde.",
      });
    },
  });

  const sendProposalPanMutation = useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: SendProposalRequest;
    }) => selfHireService.sendProposalPan(id, payload),
    onError: () => {
      toast({
        variant: "destructive",
        title: "Erro ao enviar proposta",
        description: "Verifique os dados e tente novamente.",
      });
    },
  });

  const makeProposalCrefazMutation = useMutation({
    mutationFn: (payload: MakeProposalCrefazPayload) =>
      selfHireService.makeProposalCrefaz(payload),
    onError: (error: any) => {
      toast({
        title: "Erro ao criar proposta",
        description: error?.message || "Tente novamente mais tarde.",
        variant: "destructive",
      });
    },
  });

  const simulateCltMutation = useMutation({
    mutationFn: ({ cpf, params }: { cpf: string; params: SimulateCltParams }) =>
      selfHireService.simulateClt(cpf, params),
    onError: (error: any) => {
      toast({
        title: "Erro ao simular CLT",
        description: error?.message || "Tente novamente mais tarde.",
        variant: "destructive",
      });
    },
  });

  const uploadAttachmentCrefazMutation = useMutation({
    mutationFn: ({
      id,
      documentoId,
      file,
    }: {
      id: string;
      documentoId: string;
      file: File;
    }) => selfHireService.uploadAttachmentCrefaz(id, documentoId, file),
    onError: (error: any) => {
      toast({
        title: "Erro ao enviar anexo",
        description: error?.message || "Tente novamente mais tarde.",
        variant: "destructive",
      });
    },
  });

  return {
    createCustomerMutation,
    makeProposalPanMutation,
    generateOffersPanMutation,
    getPublicTransactionPanMutation,
    sendProposalPanMutation,

    makeProposalCrefazMutation,
    uploadAttachmentCrefazMutation,

    simulateCltMutation,
  };
}
